var codeblock_default = {
  "blockStyleSpacing": "Gjckp",
  "codeBlock": "UCTrf Gjckp",
  "renderedInTable": "SL0U3"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
